import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    communityId: null,
    communityName: '',
    communitySlug: '',
    coverImageUrl: '',
    memberCount: null,
    description: '',
    buttonText: '',
    showMemberCount: true,
    showChannels: true,
    showTiers: true,
    layout: 'card',
    tiers: [],
    channels: [],
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
};

export const communitySlice = createSlice({
  name: 'community',
  initialState,
  reducers: {
    communityStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
        communityId: blockContent.communityId ?? null,
        communityName: blockContent.communityName ?? '',
        communitySlug: blockContent.communitySlug ?? '',
        coverImageUrl: blockContent.coverImageUrl ?? '',
        memberCount: blockContent.memberCount ?? null,
        description: blockContent.description ?? '',
        buttonText: blockContent.buttonText ?? '',
        showMemberCount: blockContent.showMemberCount !== false,
        showChannels: blockContent.showChannels !== false,
        showTiers: blockContent.showTiers !== false,
        layout: blockContent.layout ?? 'card',
        tiers: blockContent.tiers ?? [],
        channels: blockContent.channels ?? [],
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    communityClear: () => initialState,

    communityUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    communityUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    communityUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    communityUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const {
  communityStore,
  communityClear,
  communityUpdateIsLoading,
  communityUpdateIsActive,
  communityUpdateBlockContent,
  communityUpdateBlockDesign,
} = communitySlice.actions;

export const selectCommunityIsLoading = (state) => state.community.isLoading;

export const selectCommunityId = (state) => state.community.id;
export const selectCommunityUID = (state) => state.community.uid;
export const selectCommunitySID = (state) => state.community.sid;

export const selectCommunityBlockContent = (state) => state.community.blockContent;
export const selectCommunityBlockDesign = (state) => state.community.blockDesign;
export const selectCommunityButtonDesign = (state) => state.community.buttonDesign;
export const selectCommunityItemDesign = (state) => state.community.itemDesign;
export const selectCommunityContainerDesign = (state) => state.community.containerDesign;

export default communitySlice.reducer;
